export const validateTimeSlot =
  (label: string, required: boolean, supportsSelections?: boolean, supportsTimeslots?: boolean) =>
  (value: any) => {
    if (!required) {
      return undefined;
    }

    if (value !== undefined && value?.timeslot) {
      return undefined;
    }

    if (
      supportsTimeslots &&
      supportsSelections &&
      value !== undefined &&
      value?.isSelected &&
      value?.timeslot
    ) {
      return undefined;
    }

    if (supportsTimeslots && supportsSelections && value !== undefined && !value?.isSelected) {
      return undefined;
    }

    if (!supportsTimeslots && supportsSelections && value !== undefined) {
      return undefined;
    }

    return [
      {
        code: 'selectionRequired',
        label,
      },
    ];
  };
